module.exports = __webpack_public_path__ + "img/loading.400cf8ac.svg";